import React, { useEffect, useState } from "react";
import styled from "styled-components";
import api from "../api";

/* Formação é calculada a partir da escalação real para evitar inconsistências de esquema_id. */

/* ===== Overlay & Container ===== */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 12px;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

const Container = styled.div`
  background: #1a1a2e;
  border-radius: 14px;
  width: 100%;
  max-width: 440px;
  height: min(92vh, 740px);
  overflow: hidden;
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const BodyContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  overscroll-behavior: contain;
`;

const Conteudo = styled.div`
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 13px 16px 10px;
  background: #16213e;
  border-radius: 14px 14px 0 0;
  flex-shrink: 0;
`;

const Title = styled.h2`
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  color: #aaa;
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  margin-left: 8px;
  &:hover { color: #fff; }
`;

const ResumoRow = styled.div`
  background: #16213e;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 12px 8px;
  flex-shrink: 0;
`;

const ResumoBadge = styled.div`
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  font-size: ${props => props.tipo === "pontos" ? "14px" : "12px"};
  font-weight: ${props => props.tipo === "pontos" ? "700" : "600"};
  color: ${props => props.tipo === "pontos" ? "#f0db4f" : "#8fe18f"};
  letter-spacing: 0.5px;
  white-space: nowrap;
`;

const ViewToggleBar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

const ViewToggleBtn = styled.button`
  border: 1px solid ${props => props.active ? "#6fc86f" : "rgba(255,255,255,0.25)"};
  background: ${props => props.active ? "rgba(111,200,111,0.2)" : "rgba(255,255,255,0.08)"};
  color: ${props => props.active ? "#bff6bf" : "#d7dbe0"};
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  cursor: pointer;
`;

const AvatarBtn = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  border-radius: 50%;
  line-height: 0;
`;

const DetalheOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
`;

const DetalheCard = styled.div`
  width: 100%;
  max-width: 360px;
  background: #111b30;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  overflow: hidden;
`;

const DetalheHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.06);
`;

const DetalheTitulo = styled.div`
  color: #f3f5f7;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DetalheSubtitulo = styled.div`
  color: #b9c0c7;
  font-size: 11px;
  margin-top: 2px;
`;

const DetalheFechar = styled.button`
  background: transparent;
  border: none;
  color: #cfd6de;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
`;

const DetalheBody = styled.div`
  padding: 10px 12px 12px;
`;

const DetalhePontos = styled.div`
  color: #f0db4f;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
`;

const ScoutsTabela = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  overflow: hidden;
`;

const ScoutsCabecalho = styled.div`
  display: grid;
  grid-template-columns: 1fr 56px 64px;
  gap: 8px;
  align-items: center;
  padding: 7px 8px;
  background: rgba(255, 255, 255, 0.08);
  color: #cfd6de;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ScoutLinha = styled.div`
  display: grid;
  grid-template-columns: 1fr 56px 64px;
  gap: 8px;
  align-items: center;
  padding: 7px 8px;
  background: rgba(255, 255, 255, 0.04);

  &:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
`;

const ScoutColuna = styled.div`
  color: #e8edf2;
  font-size: 12px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ScoutColunaNumero = styled.div`
  text-align: right;
  font-size: 12px;
  font-weight: 700;
  color: ${props => props.positivo ? "#6fe86f" : props.negativo ? "#ff7d7d" : "#e8edf2"};
`;

const SemScout = styled.div`
  color: #9aa3ad;
  font-size: 12px;
`;

/* ===== Campo ===== */
const Campo = styled.div`
  position: relative;
  background: linear-gradient(180deg, #1e6b1e 0%, #27933a 40%, #2aad44 50%, #27933a 60%, #1e6b1e 100%);
  margin: 0 16px 0;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.55);
  padding: 10px 6px 14px;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
`;

const CenterLine = styled.div`
  position: absolute;
  left: 6%;
  right: 6%;
  top: 50%;
  transform: translateY(-50%);
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
  pointer-events: none;
`;

const CenterCircle = styled.div`
  position: absolute;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

const Linha = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.slots || 1}, minmax(44px, max-content));
  gap: 6px;
  position: relative;
  z-index: 1;
  min-height: 72px;
  align-items: center;
  padding: 2px 0;
  justify-items: center;
  justify-content: center;
`;

const LinhaLabel = styled.div`
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 8px;
  color: rgba(255,255,255,0.3);
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-weight: 700;
  pointer-events: none;
  user-select: none;
`;

/* ===== Banco ===== */
const BancoWrapper = styled.div`
  margin: 6px 10px 10px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 8px 10px;
`;

const BancoLabel = styled.div`
  font-size: 10px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 8px;
  text-align: center;
`;

const BancoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2px;
`;

const TecnicoCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 4px;
  border-right: 1px solid rgba(255, 255, 255, 0.18);
  margin-top: 2px;
`;

const TecnicoLabel = styled.div`
  font-size: 9px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 3px;
`;

const ReservasRow = styled.div`
  display: flex;
  gap: 2px;
  flex-wrap: nowrap;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
  overflow-x: auto;
`;

/* ===== AtletaCard ===== */
const AtletaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${props => props.compacto ? "42px" : props.small ? "46px" : "54px"};
  position: relative;
  opacity: ${props => props.naoJogou ? 0.45 : 1};
  transition: opacity 0.2s;
  border-radius: 8px;
  padding: 2px;
  background: transparent;
  box-shadow: none;
`;

const BadgeIcon = styled.span`
  font-size: 11px;
  position: absolute;
  top: -4px;
  right: -3px;
  z-index: 2;
  line-height: 1;
  filter: drop-shadow(0 0 2px rgba(0,0,0,0.6));
`;


const FotoCircle = styled.div`
  width: ${props => props.compacto ? "30px" : props.small ? "34px" : "40px"};
  height: ${props => props.compacto ? "30px" : props.small ? "34px" : "40px"};
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 2px solid ${
    props => props.capitao
      ? "#f0db4f"
      : props.naoJogou
        ? "rgba(180,60,60,0.6)"
        : "rgba(255,255,255,0.45)"
  };
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.compacto ? "12px" : props.small ? "14px" : "18px"};
  flex-shrink: 0;
`;

const Foto = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const AtletaNome = styled.div`
  font-size: ${props => props.compacto ? "8px" : "9px"};
  color: #e8e8e8;
  text-align: center;
  margin-top: 3px;
  max-width: ${props => props.compacto ? "42px" : "54px"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
`;

const AtletaPts = styled.div`
  font-size: ${props => props.compacto ? "9px" : "10px"};
  font-weight: 700;
  color: ${props => props.positivo ? "#6fe86f" : "#aaa"};
  text-align: center;
  line-height: 1.1;
`;

const CapTag = styled.div`
  font-size: 8px;
  color: #f0db4f;
  text-align: center;
  line-height: 1;
`;

const StatusTag = styled.div`
  font-size: 8px;
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
  color: ${props => props.jogandoAgora ? "#6fffa2" : "#b9c0c7"};
`;

const SlotVazio = styled.div`
  width: 100%;
  max-width: 54px;
  height: 66px;
  border-radius: 8px;
  border: 1px dashed rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.04);
`;

/* ===== Lista ===== */
const ListaWrapper = styled.div`
  margin: 0 10px 10px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
  height: 100%;
  min-height: 0;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
`;

const ListaSecao = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
`;

const ListaSecaoTitulo = styled.div`
  background: rgba(255, 255, 255, 0.08);
  color: #cdd5df;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  padding: 7px 10px;
`;

const ListaItem = styled.div`
  display: grid;
  grid-template-columns: 20px 32px 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
`;

const ListaBadges = styled.div`
  width: 20px;
  font-size: 11px;
  text-align: center;
  line-height: 1;
`;

const ListaFotoCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid ${props => props.capitao ? "#f0db4f" : props.naoJogou ? "rgba(180,60,60,0.6)" : "rgba(255,255,255,0.45)"};
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
`;

const ListaFoto = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ListaInfo = styled.div`
  min-width: 0;
`;

const ListaNomeLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const ListaMeta = styled.div`
  color: #9fb0c1;
  font-size: 10px;
  margin-top: 2px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

const ListaNome = styled.span`
  color: #f3f5f7;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ListaStatus = styled.span`
  color: ${props => props.jogandoAgora ? "#6fffa2" : "#b9c0c7"};
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
`;

const ListaPts = styled.div`
  color: ${props => props.positivo ? "#6fe86f" : "#d7dbe0"};
  font-size: 12px;
  font-weight: 700;
`;

function obterStatusAtleta(atleta) {
  const status = Number(atleta?.statusAtletaRodada || 0);
  if (status === 2) return { texto: "", jogandoAgora: true };
  if (status === 3) return { texto: "✅ Ja jogou", jogandoAgora: false };
  if (status === 4) return { texto: "⛔ Nao entrou", jogandoAgora: false };
  return { texto: "", jogandoAgora: false };
}

function normalizarFotoAtleta(url) {
  if (!url) return "";
  // O Cartola retorna várias silhuetas com placeholder FORMATO.
  return String(url).replace("FORMATO", "140x140");
}

function montarLinhaComFormacao(jogadores, quantidadeEsperada) {
  const lista = Array.isArray(jogadores) ? [...jogadores] : [];
  const qtd = Math.max(0, Number(quantidadeEsperada || 0));

  const slots = Math.max(qtd, lista.length);
  if (slots === 0) return lista;

  while (lista.length < slots)
    lista.push(null);

  return lista;
}

const POSICAO_LABEL = {
  1: "Goleiro",
  2: "Lateral",
  3: "Zagueiro",
  4: "Meia",
  5: "Atacante",
  6: "Tecnico",
};

const POSICAO_CURTA = {
  1: "GOL",
  2: "LAT",
  3: "ZAG",
  4: "MEI",
  5: "ATA",
  6: "TEC",
};

const SCOUT_LABEL = {
  G: "Gol",
  A: "Assistencia",
  FT: "Final na trave",
  FD: "Finalizacao defendida",
  FF: "Finalizacao pra fora",
  FS: "Falta sofrida",
  FC: "Falta cometida",
  DS: "Desarme",
  SG: "Sem gol sofrido",
  DE: "Defesa",
  GS: "Gol sofrido",
  I: "Impedimento",
  CA: "Cartao amarelo",
  CV: "Cartao vermelho",
  V: "Vitoria do time",
};

const SCOUT_PONTOS = {
  G: 8,
  A: 5,
  FT: 3,
  FD: 1.2,
  FF: 0.8,
  FS: 0.5,
  FC: -0.3,
  DS: 1.5,
  SG: 5,
  DE: 1.3,
  GS: -1,
  I: -0.1,
  CA: -1,
  CV: -3,
  V: 1,
};

const SCOUT_ORDEM = ["G", "A", "FT", "FD", "FF", "FS", "FC", "SG", "DS", "DE", "GS", "I", "CA", "CV", "V"];

function extrairScouts(atleta) {
  const scout = atleta?.scout;
  if (!scout || typeof scout !== "object") return [];

  const pares = Object.entries(scout)
    .filter(([, valor]) => typeof valor === "number" && valor !== 0)
    .map(([chave, valor]) => ({
      chave: String(chave).toUpperCase(),
      valor: Number(valor),
      ordem: SCOUT_ORDEM.includes(String(chave).toUpperCase()) ? SCOUT_ORDEM.indexOf(String(chave).toUpperCase()) : 999,
      label: SCOUT_LABEL[String(chave).toUpperCase()] || String(chave).toUpperCase(),
    }))
    .map(item => ({
      ...item,
      pontosScout: SCOUT_PONTOS[item.chave] || 0,
      pontosItem: item.valor * (SCOUT_PONTOS[item.chave] || 0),
    }))
    .sort((a, b) => a.ordem - b.ordem || a.chave.localeCompare(b.chave));

  return pares;
}

function formatarPontosScout(valor) {
  const numero = Number(valor || 0);
  return numero.toFixed(2).replace(".", ",");
}

function montarLinhaDefensiva(laterais, zagueiros) {
  const lats = Array.isArray(laterais) ? [...laterais] : [];
  const zags = Array.isArray(zagueiros) ? [...zagueiros] : [];
  const total = lats.length + zags.length;
  if (total === 0) return [];

  const linha = new Array(total).fill(null);
  let left = 0;
  let right = total - 1;

  // Laterais ficam preferencialmente nas pontas do campo.
  while (lats.length > 0 && left <= right) {
    linha[left] = lats.shift();
    left += 1;
    if (lats.length > 0 && left <= right) {
      linha[right] = lats.shift();
      right -= 1;
    }
  }

  // Zagueiros ocupam o miolo da defesa.
  while (zags.length > 0 && left <= right) {
    linha[left] = zags.shift();
    left += 1;
  }

  return linha.filter(Boolean);
}

/* ===== CardAtleta ===== */
const CardAtleta = ({ atleta, ehCapitao, isTecnico, ehReservaLuxo, onAbrirDetalhes, compacto }) => {
  const statusAtleta = obterStatusAtleta(atleta);
  const naoJogou = !statusAtleta.jogandoAgora && atleta.entrou_em_campo === false;
  const pontos = ehCapitao ? atleta.pontos_num * 1.5 : atleta.pontos_num;
  const nome = atleta.apelido_abreviado || atleta.apelido || atleta.nome || "?";
  const fotoUrl = normalizarFotoAtleta(atleta.foto);
  const [fotoError, setFotoError] = useState(false);

  return (
    <AtletaWrapper small={isTecnico} compacto={compacto} naoJogou={naoJogou} jogandoAgora={statusAtleta.jogandoAgora}>
      {ehCapitao && <BadgeIcon style={{ right: "2px", top: "-1px" }}>⭐</BadgeIcon>}
      {statusAtleta.jogandoAgora && <BadgeIcon style={{ right: "auto", left: "2px", top: "auto", bottom: "24px", transform: "none" }}>🟢</BadgeIcon>}
      {ehReservaLuxo && <BadgeIcon style={{ right: "auto", left: "2px", top: "-1px" }}>💎</BadgeIcon>}
      <AvatarBtn
        type="button"
        onClick={() => onAbrirDetalhes?.(atleta, { ehCapitao, ehReservaLuxo, isTecnico })}
        title="Ver detalhes do jogador"
      >
        <FotoCircle capitao={ehCapitao} naoJogou={naoJogou} small={isTecnico} compacto={compacto}>
          {fotoUrl && !fotoError ? (
            <Foto src={fotoUrl} alt={nome} onError={() => setFotoError(true)} />
          ) : (
            <span>⚽</span>
          )}
        </FotoCircle>
      </AvatarBtn>
      <AtletaNome title={nome} compacto={compacto}>{nome}</AtletaNome>
      <AtletaPts positivo={pontos > 0} compacto={compacto}>
        {pontos.toFixed(1)}
      </AtletaPts>
      {ehCapitao && <CapTag>×1.5</CapTag>}
      {!isTecnico && statusAtleta.texto && (
        <StatusTag jogandoAgora={statusAtleta.jogandoAgora}>{statusAtleta.texto}</StatusTag>
      )}
    </AtletaWrapper>
  );
};

const ListaAvatar = ({ atleta, ehCapitao, naoJogou, onAbrirDetalhes }) => {
  const fotoUrl = normalizarFotoAtleta(atleta?.foto);
  const nome = atleta?.apelido_abreviado || atleta?.apelido || atleta?.nome || "?";
  const [fotoError, setFotoError] = useState(false);

  return (
    <AvatarBtn
      type="button"
      onClick={() => onAbrirDetalhes?.(atleta, { ehCapitao })}
      title="Ver detalhes do jogador"
    >
      <ListaFotoCircle capitao={ehCapitao} naoJogou={naoJogou}>
        {fotoUrl && !fotoError ? (
          <ListaFoto src={fotoUrl} alt={nome} onError={() => setFotoError(true)} />
        ) : (
          <span>⚽</span>
        )}
      </ListaFotoCircle>
    </AvatarBtn>
  );
};

/* ===== CampoFutebol ===== */
const CampoFutebol = ({ idTimeRodada, nomeTime, onClose }) => {
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [viewMode, setViewMode] = useState("campo");
  const [detalheAtleta, setDetalheAtleta] = useState(null);

  const handleListaWheel = (e) => {
    const el = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    el.scrollTop += e.deltaY;
  };

  const abrirDetalhesAtleta = (atleta, meta = {}) => {
    if (!atleta) return;
    setDetalheAtleta({ atleta, meta });
  };

  const atletasResumo = dados?.atletas || [];
  const capitaoResumoId = dados?.capitao_id;
  const totalPtsResumo = atletasResumo.reduce(
    (acc, a) => acc + (a.atleta_id === capitaoResumoId ? a.pontos_num * 1.5 : a.pontos_num),
    0
  );
  const defesaResumo = atletasResumo.filter(a => a.posicao_id === 2 || a.posicao_id === 3);
  const meiasResumo = atletasResumo.filter(a => a.posicao_id === 4);
  const atacantesResumo = atletasResumo.filter(a => a.posicao_id === 5);
  const formacaoResumo = atletasResumo.length
    ? `${defesaResumo.length}-${meiasResumo.length}-${atacantesResumo.length}`
    : "-";

  useEffect(() => {
    api.get(`liga/detalheTimeRodada/${idTimeRodada}`)
      .then(res => { setDados(res.data); setLoading(false); })
      .catch(() => { setErro("Erro ao carregar escalação do time."); setLoading(false); });
  }, [idTimeRodada]);

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  const renderConteudo = () => {
    if (loading) {
      return (
        <div style={{ padding: "40px 16px", textAlign: "center", color: "#aaa" }}>
          ⏳ Carregando escalação...
        </div>
      );
    }
    if (erro || !dados) {
      return (
        <div style={{ padding: "40px 16px", textAlign: "center", color: "#e74c3c" }}>
          {erro || "Sem dados disponíveis."}
        </div>
      );
    }

    const { atletas = [], reservas = [], capitao_id, reserva_luxo_id } = dados;

    const goleiros  = atletas.filter(a => a.posicao_id === 1);
    const laterais  = atletas.filter(a => a.posicao_id === 2);
    const zagueiros = atletas.filter(a => a.posicao_id === 3);
    const meias     = atletas.filter(a => a.posicao_id === 4);
    const atacantes = atletas.filter(a => a.posicao_id === 5);
    const tecnico   = atletas.find(a => a.posicao_id === 6);

    // Defesa organizada por posição: laterais nas pontas, zagueiros no centro.
    const defesa = montarLinhaDefensiva(laterais, zagueiros);

    const esquema = {
      nome: `${defesa.length}-${meias.length}-${atacantes.length}`,
      def: defesa.length,
      mei: meias.length,
      ata: atacantes.length,
    };
    const linhaAta = montarLinhaComFormacao(atacantes, esquema.ata);
    const linhaMei = montarLinhaComFormacao(meias, esquema.mei);
    const linhaDef = montarLinhaComFormacao(defesa, esquema.def);

    const reservasList = reservas || [];

    const renderListaItem = (a, { ehCapitao = false, ehReservaLuxo = false } = {}) => {
      const statusAtleta = obterStatusAtleta(a);
      const naoJogou = !statusAtleta.jogandoAgora && a.entrou_em_campo === false;
      const pontos = ehCapitao ? a.pontos_num * 1.5 : a.pontos_num;
      const nome = a.apelido_abreviado || a.apelido || a.nome || "?";
      const posicao = POSICAO_CURTA[a.posicao_id] || "-";
      const badges = [
        ehReservaLuxo ? "💎" : "",
        statusAtleta.jogandoAgora ? "🟢" : "",
        ehCapitao ? "⭐" : "",
      ].filter(Boolean).join(" ");

      return (
        <ListaItem key={`lista-${a.atleta_id}-${a.posicao_id || "res"}`}>
          <ListaBadges>{badges || ""}</ListaBadges>
          <ListaAvatar atleta={a} ehCapitao={ehCapitao} naoJogou={naoJogou} onAbrirDetalhes={abrirDetalhesAtleta} />
          <ListaInfo>
            <ListaNomeLinha>
              <ListaNome title={nome}>{nome}</ListaNome>
              {statusAtleta.texto && (
                <ListaStatus jogandoAgora={statusAtleta.jogandoAgora}>{statusAtleta.texto}</ListaStatus>
              )}
            </ListaNomeLinha>
            <ListaMeta>{posicao}</ListaMeta>
          </ListaInfo>
          <ListaPts positivo={pontos > 0}>{pontos.toFixed(1)}</ListaPts>
        </ListaItem>
      );
    };

    const goleirosList = atletas.filter(a => a.posicao_id === 1);
    const defesaList = atletas.filter(a => a.posicao_id === 2 || a.posicao_id === 3);
    const meiasList = atletas.filter(a => a.posicao_id === 4);
    const atacantesList = atletas.filter(a => a.posicao_id === 5);

    // A API não expõe substituição explícita titular<->reserva, então evitamos setas para não gerar falso positivo.

    return (
      <Conteudo>
        {viewMode === "campo" ? (
          <>
            <Campo>
              <CenterLine />
              <CenterCircle />
              {linhaAta.length > 0 && (
                <Linha slots={linhaAta.length}>
                  <LinhaLabel>ATA</LinhaLabel>
                  {linhaAta.map((a, idx) => a ? (
                    <CardAtleta key={`ata-${a.atleta_id}`} atleta={a} ehCapitao={a.atleta_id === capitao_id} onAbrirDetalhes={abrirDetalhesAtleta} />
                  ) : (
                    <SlotVazio key={`ata-slot-${idx}`} />
                  ))}
                </Linha>
              )}
              {linhaMei.length > 0 && (
                <Linha slots={linhaMei.length}>
                  <LinhaLabel>MEI</LinhaLabel>
                  {linhaMei.map((a, idx) => a ? (
                    <CardAtleta key={`mei-${a.atleta_id}`} atleta={a} ehCapitao={a.atleta_id === capitao_id} onAbrirDetalhes={abrirDetalhesAtleta} />
                  ) : (
                    <SlotVazio key={`mei-slot-${idx}`} />
                  ))}
                </Linha>
              )}
              {linhaDef.length > 0 && (
                <Linha slots={linhaDef.length}>
                  <LinhaLabel>DEF</LinhaLabel>
                  {linhaDef.map((a, idx) => a ? (
                    <CardAtleta key={`def-${a.atleta_id}`} atleta={a} ehCapitao={a.atleta_id === capitao_id} onAbrirDetalhes={abrirDetalhesAtleta} />
                  ) : (
                    <SlotVazio key={`def-slot-${idx}`} />
                  ))}
                </Linha>
              )}
              {goleiros.length > 0 && (
                <Linha>
                  <LinhaLabel>GOL</LinhaLabel>
                  {goleiros.map(a => (
                    <CardAtleta key={a.atleta_id} atleta={a} ehCapitao={a.atleta_id === capitao_id} onAbrirDetalhes={abrirDetalhesAtleta} />
                  ))}
                </Linha>
              )}
            </Campo>

            <BancoWrapper>
              <BancoLabel>Banco de reservas</BancoLabel>
              <BancoRow>
                {tecnico && (
                  <TecnicoCol>
                    <CardAtleta atleta={tecnico} isTecnico onAbrirDetalhes={abrirDetalhesAtleta} />
                    <TecnicoLabel>Técnico</TecnicoLabel>
                  </TecnicoCol>
                )}
                <ReservasRow>
                  {reservasList.map(a => (
                    <CardAtleta
                      key={a.atleta_id}
                      atleta={a}
                      ehReservaLuxo={a.atleta_id === reserva_luxo_id}
                      onAbrirDetalhes={abrirDetalhesAtleta}
                      compacto
                    />
                  ))}
                </ReservasRow>
              </BancoRow>
            </BancoWrapper>
          </>
        ) : (
          <ListaWrapper onWheel={handleListaWheel}>
            <ListaSecao>
              <ListaSecaoTitulo>Goleiro</ListaSecaoTitulo>
              {goleirosList.map(a => renderListaItem(a, { ehCapitao: a.atleta_id === capitao_id }))}
            </ListaSecao>

            <ListaSecao>
              <ListaSecaoTitulo>Defesa</ListaSecaoTitulo>
              {defesaList.map(a => renderListaItem(a, { ehCapitao: a.atleta_id === capitao_id }))}
            </ListaSecao>

            <ListaSecao>
              <ListaSecaoTitulo>Meio</ListaSecaoTitulo>
              {meiasList.map(a => renderListaItem(a, { ehCapitao: a.atleta_id === capitao_id }))}
            </ListaSecao>

            <ListaSecao>
              <ListaSecaoTitulo>Ataque</ListaSecaoTitulo>
              {atacantesList.map(a => renderListaItem(a, { ehCapitao: a.atleta_id === capitao_id }))}
            </ListaSecao>

            {tecnico && (
              <ListaSecao>
                <ListaSecaoTitulo>Técnico</ListaSecaoTitulo>
                {renderListaItem(tecnico)}
              </ListaSecao>
            )}

            <ListaSecao>
              <ListaSecaoTitulo>Reservas</ListaSecaoTitulo>
              {reservasList.map(a => renderListaItem(a, { ehReservaLuxo: a.atleta_id === reserva_luxo_id }))}
            </ListaSecao>
          </ListaWrapper>
        )}
      </Conteudo>
    );
  };

  return (
    <Overlay onClick={onClose}>
      <Container onClick={e => e.stopPropagation()}>
        <Header>
          <Title>⚽ {nomeTime}</Title>
          <ViewToggleBar>
            <ViewToggleBtn
              type="button"
              active={viewMode === "campo"}
              onClick={() => setViewMode("campo")}
            >
              Campo
            </ViewToggleBtn>
            <ViewToggleBtn
              type="button"
              active={viewMode === "lista"}
              onClick={() => setViewMode("lista")}
            >
              Lista
            </ViewToggleBtn>
          </ViewToggleBar>
          <CloseBtn onClick={onClose}>✕</CloseBtn>
        </Header>
        {!loading && !erro && dados && (
          <ResumoRow>
            <ResumoBadge tipo="pontos">{totalPtsResumo.toFixed(2)} pts</ResumoBadge>
            <ResumoBadge>▣ {formacaoResumo}</ResumoBadge>
          </ResumoRow>
        )}
        <BodyContent>
          {renderConteudo()}
        </BodyContent>
      </Container>

      {detalheAtleta && (
        <DetalheOverlay
          onClick={(e) => {
            e.stopPropagation();
            setDetalheAtleta(null);
          }}
        >
          <DetalheCard onClick={e => e.stopPropagation()}>
            <DetalheHeader>
              <div style={{ minWidth: 0 }}>
                <DetalheTitulo>
                  {detalheAtleta.atleta.apelido || detalheAtleta.atleta.nome || "Jogador"}
                </DetalheTitulo>
                <DetalheSubtitulo>
                  {POSICAO_LABEL[detalheAtleta.atleta.posicao_id] || "Posicao"}
                </DetalheSubtitulo>
              </div>
              <DetalheFechar onClick={() => setDetalheAtleta(null)}>✕</DetalheFechar>
            </DetalheHeader>
            <DetalheBody>
              <DetalhePontos>
                {(
                  detalheAtleta.meta?.ehCapitao
                    ? detalheAtleta.atleta.pontos_num * 1.5
                    : detalheAtleta.atleta.pontos_num
                ).toFixed(2)} pts
              </DetalhePontos>

              {extrairScouts(detalheAtleta.atleta).length > 0 ? (
                <ScoutsTabela>
                  <ScoutsCabecalho>
                    <div>Scout</div>
                    <div style={{ textAlign: "right" }}>Quant.</div>
                    <div style={{ textAlign: "right" }}>Pont.</div>
                  </ScoutsCabecalho>

                  {extrairScouts(detalheAtleta.atleta).map((item) => (
                    <ScoutLinha key={`${detalheAtleta.atleta.atleta_id}-${item.chave}`}>
                      <ScoutColuna>{item.label}</ScoutColuna>
                      <ScoutColunaNumero>{item.valor}</ScoutColunaNumero>
                      <ScoutColunaNumero positivo={item.pontosItem > 0} negativo={item.pontosItem < 0}>
                        {formatarPontosScout(item.pontosItem)}
                      </ScoutColunaNumero>
                    </ScoutLinha>
                  ))}
                </ScoutsTabela>
              ) : (
                <SemScout>Sem parciais detalhadas para este jogador no momento.</SemScout>
              )}
            </DetalheBody>
          </DetalheCard>
        </DetalheOverlay>
      )}
    </Overlay>
  );
};

export default CampoFutebol;
